import styled from '@emotion/styled';
import { Button, Col, Modal, Tag } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';

import ImagesPreview from 'components/_local/ImagesPreview/ImagesPreview';
import PriceDisplay from 'components/_local/PriceDisplay/PriceDisplay';

export const ContainerModal = styled(Modal)`
  width: 100% !important;
  top: 8vh;
  max-height: ${props => (props.isCompactScrollable ? '85vh' : 'auto')};

  ${props =>
    props.isCompactScrollable &&
    `
    .ant-modal-content {
      max-height: 85vh;
      display: flex;
      flex-direction: column;
    }

    .ant-modal-header {
      padding: 10px 14px !important;
      margin-bottom: 0 !important;
    }

    .ant-modal-body {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 14px 14px 10px !important;
    }

    .ant-modal-close {
      top: 10px;
      inset-inline-end: 10px;
    }

    .ant-modal-footer {
      margin-top: 0;
      background: #fff;
      padding: 10px 14px 14px !important;
    }
  `}

  @media (min-width: 768px) {
    width: 80% !important;
  }

  @media (min-width: 1024px) {
    width: 60% !important;
  }

  @media (min-width: 1400px) {
    width: 50% !important;
  }

  @media (min-width: 1600px) {
    width: 40% !important;
  }

  @media (min-width: 2560px) {
    width: 30% !important;
  }
`;

export const PhotoCol = styled(Col)`
  padding: 0 !important;
  align-items: center;
  background-color: #dfdfdf;
  display: flex;
  justify-content: center;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const ProductModalImageFrame = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #dfdfdf;

  > .ant-image {
    width: 100% !important;
    height: 100% !important;
    display: block !important;
  }

  > .ant-image .ant-image-img {
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    max-height: none !important;
    object-fit: cover !important;
    object-position: center;
    display: block;
  }
`;

export const CompactHeaderImageFrame = styled(ProductModalImageFrame)`
  width: 128px !important;
  min-width: 128px;
  max-width: 128px;
  background-color: ${props => props.theme.color.lightGrey};
  border-radius: 10px;

  > .ant-image .ant-image-img {
    border-radius: 10px;
  }

  @media (max-width: 420px) {
    width: 112px !important;
    min-width: 112px;
    max-width: 112px;
  }

  @media (max-width: 360px) {
    width: 104px !important;
    min-width: 104px;
    max-width: 104px;
  }
`;

export const ProductDetailsPreviewImg = styled(ImagesPreview)`
  width: 100% !important;
  height: 100% !important;
  max-height: none !important;
  object-fit: cover !important;
  display: block;
`;

export const ProductName = styled.h2``;

export const ProductKeyword = styled.h2`
  color: grey;
`;

export const ProductDesc = styled.p`
  white-space: pre-wrap;
  color: ${props => props.theme.color.grey};
`;

export const CompactProductDesc = styled(ProductDesc)`
  font-size: 13px;
  line-height: 1.45;
  margin-top: 0;
  margin-bottom: 0;
`;

export const ProductTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${props => (props.$compact ? '6px' : '8px')};
  margin-top: ${props => (props.$compact ? '6px' : '12px')};
  margin-bottom: 8px;
`;

export const ProductCategoryTag = styled(Tag)`
  margin: 0 !important;
  padding: ${props => (props.$compact ? '2px 8px' : '4px 12px')};
  font-size: ${props => (props.$compact ? '11px' : '13px')};
  line-height: 1.35;
  border-radius: 999px;
  border: 1px solid ${props => props.theme.color.borderColor};
  background: ${props => props.theme.color.lighterPrimary};
  color: ${props => props.theme.color.black};
`;

export const ProductNameWithVariances = styled.h4`
  color: #000000d9;
  margin-bottom: 0 !important;
`;

export const CompactModalSectionTitle = styled(ProductNameWithVariances)`
  font-size: 14px !important;
  line-height: 1.35 !important;
  margin-bottom: 6px !important;
`;

export const CompactModalSectionDesc = styled(ProductDesc)`
  font-size: 13px;
  line-height: 1.45;
  margin-bottom: 0;
`;

export const QtyButtonGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => (props.isCompactFooter ? '100%' : 'auto')};

  .ant-form-item {
    flex: 1;
    margin: 0 !important;
    min-width: 0;
  }

  .ant-form-item-control {
    width: 100%;
  }

  .ant-form-item-control-input {
    min-height: 0;
  }

  .ant-input {
    text-align: center;
  }
`;

export const QtyStepperControlsRow = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: ${props => (props.$compact ? '8px' : '10px')};
`;

export const QtyButton = styled(Button)`
  width: 44px !important;
  min-width: 44px !important;

  ${props =>
    props.isCompactFooter &&
    `
    width: 40px !important;
    min-width: 40px !important;
  `}
`;

export const CompactFooterControls = styled.div`
  width: 100%;
  padding-top: 2px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CompactFooterTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const CompactFooterLabel = styled.span`
  color: ${props => props.theme.color.black};
  font-size: 13px;
  font-weight: ${props => props.theme.fontWeight.bold};
`;

export const CompactFooterQtyWrapper = styled.div`
  width: min(100%, 228px);
  flex-shrink: 0;
`;

export const CompactFooterHint = styled.span`
  color: #9a9a9a;
  font-size: 12px;
`;

export const CompactFooterButton = styled(Button)`
  height: 36px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CompactHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
`;

export const CompactHeaderInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CompactHeaderTitle = styled.h3`
  margin: 0 0 2px;
  color: ${props => props.theme.color.black};
  font-size: 15px;
  font-weight: ${props => props.theme.fontWeight.bold};
  line-height: 1.25;
`;

export const CompactHeaderKeyword = styled.p`
  margin: 0 0 4px;
  color: #9a9a9a;
  font-size: 13px;
  line-height: 1.35;
`;

export const CompactHeaderVarianceLabel = styled.p`
  margin: 0 0 4px;
  color: ${props => props.theme.color.black};
  font-size: 13px;
  font-weight: ${props => props.theme.fontWeight.bold};
  line-height: 1.35;
`;

export const VarianceCardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const VarianceCard = styled.button`
  flex: 0 1 auto;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid ${props => (props.isSelected ? props.theme.color.primary : '#e0e0e0')};
  background: ${props => (props.isSelected ? '#FFF7F1' : '#ffffff')};
  box-shadow: ${props => (props.isSelected ? '0 2px 6px rgba(255, 114, 18, 0.12)' : '0 1px 2px rgba(0, 0, 0, 0.04)')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  text-align: left;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;

  &:hover:not(:disabled) {
    border-color: ${props => props.theme.color.primary};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &:active:not(:disabled) {
    transform: scale(0.99);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 114, 18, 0.16);
  }

  &:disabled {
    background: #f0f0f0;
    border-style: dashed;
    box-shadow: none;
  }

  &:disabled img {
    filter: grayscale(100%);
    opacity: 0.55;
  }

  &:disabled p {
    color: #9a9a9a;
    text-decoration: line-through;
  }
`;

export const VarianceCardImage = styled.img`
  width: 40px;
  height: auto;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  border-radius: 6px;
  background: ${props => props.theme.color.white};
  flex-shrink: 0;
`;

export const VarianceCardText = styled.div`
  min-width: 0;
  overflow: hidden;
`;

export const VarianceCardTitle = styled.p`
  margin: 0;
  color: ${props => props.theme.color.black};
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeight.regular};
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CartIcon = styled(ShoppingCartOutlined)`
  color: #4f4f4f;
  font-size: 20px;
`;

export const OriPricingInfoLabel = styled(PriceDisplay)`
  font-size: ${props => (props.$compact ? '11px' : '12px')};
  color: grey;
  text-decoration: line-through;
  margin-right: 4px;
`;

export const PricingInfoLabel = styled(PriceDisplay)`
  color: ${props => (props.hasOriPrice ? props.theme.color.primary : '#000000D9')};
  font-size: ${props => (props.$compact ? '16px' : '1.5em')};
  font-weight: bold;
`;
